import { mapProps, compose } from 'recompose'
import withType from 'components/common/hoc/withType'
import BOTGlobalSearchSummary from './BOTGlobalSearchSummary'

const withFilteredResults = mapProps(({ searchResults, ...props }) => ({
  ...props,
  results: searchResults.filter(({ totalNumRecs }) => Boolean(totalNumRecs))
}))

export default compose(
  withType({ type: 'BOTGlobalSearchSummary' }),
  withFilteredResults
)(BOTGlobalSearchSummary)
